import 'env' // 全局API域名配置
import './config' // 全局配置
import './axios' // axios的全局配置
import { toJS } from 'mobx'
import { setupConfig } from '@ionic/react'

// 增加console.toJS方法console mobx数据
window.console = {
  ...console,
  toJS (...args: any[]) {
    console.log(...args.map(arg => toJS(arg)))
  }
} as Console

try {
  (window as any).buildinfo = BUILDINFO
} catch (error) {
  (window as any).buildinfo = {
    commitDate: '2022-10-28 10:59',
    buildDate: '2022-10-28 11:00:40',
  }
}

console.log('🚀 当前版本号: =>', `V${window.buildinfo?.buildDate.substr(2, 14).replace(/[-|:]/g, '').replace(' ', '-')}`)

// ionic全局设置IOS风格
setupConfig({
  mode: 'ios',
  swipeBackEnabled: false
})
